import React from 'react';
import Icon from '../../../components/AppIcon';

const BodyMeasurementTracker = ({ measurements }) => {
  return (
    <div className="bg-card border border-border rounded-lg p-4 md:p-6 shadow-md">
      <div className="flex items-center justify-between mb-4">
        <h3 className="text-lg md:text-xl font-heading font-semibold text-foreground">
          Body Measurements
        </h3>
        <button className="text-sm text-primary hover:text-primary/80 font-medium transition-smooth">
          Add Entry
        </button>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {measurements?.map((measurement, index) => (
          <div 
            key={index}
            className="flex items-center justify-between p-3 bg-muted/50 rounded-lg"
          >
            <div className="flex items-center gap-3">
              <div className="flex items-center justify-center w-8 h-8 md:w-10 md:h-10 rounded-lg bg-primary/10">
                <Icon name={measurement?.icon} size={18} color="var(--color-primary)" />
              </div>
              <div>
                <p className="text-sm md:text-base font-medium text-foreground">
                  {measurement?.label}
                </p>
                <p className="text-xs caption text-muted-foreground">
                  {measurement?.date}
                </p>
              </div>
            </div>
            <div className="text-right">
              <p className="text-lg md:text-xl font-heading font-bold text-foreground data-text">
                {measurement?.value}
              </p>
              {measurement?.change && (
                <div className={`flex items-center gap-1 justify-end text-xs ${
                  measurement?.changeType === 'positive' ? 'text-success' : 'text-error'
                }`}>
                  <Icon 
                    name={measurement?.changeType === 'positive' ? 'TrendingDown' : 'TrendingUp'} 
                    size={12} 
                  />
                  <span className="font-semibold data-text">{measurement?.change}</span>
                </div>
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default BodyMeasurementTracker;